import createService from '@/composables/db/useServiceFactory'

function capitalizeFirstLetter(word: string) {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export default function () {
  const { userId } = storeToRefs(useUserStore())
  // const entryType = computed(() => `liked${capitalizeFirstLetter(modelType)}`)
  // const service = createService(`users/${userId}/${entryType}`)

  const checkLikedComment = async (commentId: string) => {
    if (!userId.value)
      return null
    const service = createService(`users/${userId.value}/likedComments`)

    // const conditionParams = [
    //   {
    //     field: documentId,
    //     operation: 'in',
    //     value: commentIdList,
    //   },
    // ]
    // const likedComments = await service.query(conditionParams)

    const likedComment = await service.get(commentId)
    return likedComment
  }

  const checkLiked = async (modelType: string, modelId: string) => {
    if (!userId.value)
      return null
    const model = capitalizeFirstLetter(modelType)
    const service = createService(`users/${userId.value}/liked${model}`)
    const likedStory = await service.get(modelId)

    return likedStory
  }

  return {
    checkLiked,
    checkLikedComment,
  }
}
